import useSWR from "swr";
import { getUsersPaginated, type AdminUserSummary } from "../api/adminUsersApi";

export type AdminUsersSortOption = "nameAsc" | "nameDesc" | "zAsc" | "zDesc";

interface UseAdminUsersOptions {
  search?: string;
  role?: string;
  sort: AdminUsersSortOption;
  page: number;
  pageSize: number;
}

interface AdminUsersQueryResult {
  items: AdminUserSummary[];
  totalCount: number;
}

async function fetchUsers(options: UseAdminUsersOptions): Promise<AdminUsersQueryResult> {
  const response = await getUsersPaginated({
    search: options.search,
    role: options.role,
    sort: options.sort,
    skip: options.page * options.pageSize,
    take: options.pageSize,
  });
  return response;
}

export default function useAdminUsers(options: UseAdminUsersOptions) {
  const key: [string, string, string, AdminUsersSortOption, number, number] = [
    "admin-users",
    options.search ?? "",
    options.role ?? "",
    options.sort,
    options.page,
    options.pageSize,
  ];

  return useSWR<AdminUsersQueryResult>(key, () => fetchUsers(options), {
    keepPreviousData: true,
    revalidateOnFocus: false,
  });
}
